import React, { useState, useEffect, useRef } from "react";
import Panel from "@/components/Panel";
import Amplify from "@/lib/aws";
import QRCode from "qrcode.react";
import { Divider, Input } from "antd";

const Component = props => {
  console.log("MFAConfigurationView props => ", props);

  const [totpValue, setTotpValue] = useState("");  
  const [mfaErrorMsg, setMfaErrorMsg] = useState("");
  const [mfaVerificationCode, setMfaVerificationCode] = useState("");

  const codeOne = useRef();
  const codeTwo = useRef();
  const codeThree = useRef();
  const codeFour = useRef();
  const codeFive = useRef();
  const codeSix = useRef();
  const inputArray = [codeOne, codeTwo, codeThree, codeFour, codeFive, codeSix];


  const setupTotp = async () => {
    const user = await Amplify.Auth.currentAuthenticatedUser({
      bypassCache: false
    });
    const username = props.email;
    const code = await Amplify.Auth.setupTOTP(user);

    setTotpValue(
      "otpauth://totp/WSCC:" +
        username +
        "?secret=" +
        code +
        "&issuer=WSCC"
    );
  };

  useEffect(() => {
    setupTotp();
  }, []);

  const verifyMfaCode = async code => {
    setMfaErrorMsg("");
    try {
      const user = await Amplify.Auth.currentAuthenticatedUser({
        bypassCache: false
      });
      const verifyResult = await Amplify.Auth.verifyTotpToken(user, code);
      // don't forget to set TOTP as the preferred MFA method
      const preferredResult = await Amplify.Auth.setPreferredMFA(user, "TOTP");
      // clearing the custom attribute to avoid MFA setup required in the future
      await Amplify.Auth.updateUserAttributes(user, {
        "custom:mfaSetupRequired": ""
      })
      
      if (props.onComplete) {
        props.onComplete();
      }

    } catch (error) {
      console.log(error);
      setMfaVerificationCode("");
      setMfaErrorMsg("Code mismatch, please try again");
      setTimeout(() => {
        codeOne.current.focus();
      }, 50);
    }
  };

  const cleanVerificationCode = evt => {
    const inputLength = mfaVerificationCode.length;
    const val = evt.target.value;
    const code = mfaVerificationCode + val;
    setMfaVerificationCode(code);
    if (code.length === 6) {
      verifyMfaCode(code);
      return;
    }
    setTimeout(() => {
      if (inputLength <= 4) {
        inputArray[inputLength + 1].current.focus();
      }
    }, 50);
  };

  return (
    <Panel title="Two-step authentication">
        <>
          <div className="info">
            Keep your account extra secure with Multi-Factor Authentication
            (MFA).
            <style jsx>{`
              .info {
                font-size: 1em;
                font-weight: bold;
              }
            `}</style>
          </div>
          
          <div>
            <div>
              <div className="qr-content">
                <div className="info">
                  Scan this barcode using your Authenticator app to set up your account. If you do not have one, download the free {" "}
                  <a
                    href="https://support.google.com/accounts/bin/answer.py?hl=en&answer=1066447"
                    target="_blank"
                  >
                    Google Authenticator
                  </a>{" "}
                  app and make an account to proceed.
                </div>
                <div>
                  <QRCode value={totpValue} />
                </div>
              </div>
              <Divider />
              <div className="qr-content">
                <div className="info">
                  Please enter your 6-digit authentication code from the
                  Authenticator app. "{props.email}" will appear below
                  the code.
                </div>
                <div className="code-layout">
                  <div className="input-number">
                    <Input
                      disabled={mfaVerificationCode.length !== 0}
                      value={mfaVerificationCode[0] || ""}
                      onChange={cleanVerificationCode}
                      ref={codeOne}
                    ></Input>
                  </div>
                  <div className="input-number">
                    <Input
                      disabled={mfaVerificationCode.length !== 1}
                      value={mfaVerificationCode[1] || ""}
                      onChange={cleanVerificationCode}
                      ref={codeTwo}
                    ></Input>
                  </div>
                  <div className="input-number">
                    <Input
                      disabled={mfaVerificationCode.length !== 2}
                      value={mfaVerificationCode[2] || ""}
                      onChange={cleanVerificationCode}
                      ref={codeThree}
                    ></Input>
                  </div>
                  <div style={{ fontSize: "2.0em" }}>-</div>
                  <div className="input-number">
                    <Input
                      disabled={mfaVerificationCode.length !== 3}
                      value={mfaVerificationCode[3] || ""}
                      onChange={cleanVerificationCode}
                      ref={codeFour}
                    ></Input>
                  </div>
                  <div className="input-number">
                    <Input
                      disabled={mfaVerificationCode.length !== 4}
                      value={mfaVerificationCode[4] || ""}
                      onChange={cleanVerificationCode}
                      ref={codeFive}
                    ></Input>
                  </div>
                  <div className="input-number">
                    <Input
                      disabled={mfaVerificationCode.length !== 5}
                      value={mfaVerificationCode[5] || ""}
                      onChange={cleanVerificationCode}
                      ref={codeSix}
                    ></Input>
                  </div>
                </div>
                <div className="error">{mfaErrorMsg}</div>
              </div>
            </div>
            <style jsx>{`
              .__container {
                display: flex;
                flex-direction: column;
              }
              .qr-content {
                display: flex;
                flex-direction: column;
                align-items: center;
              }
              .steps-content {
                margin: 1em 0;
              }
              .info {
                margin: 1em 0;
              }
              a {
                color: blue;
              }
              a:hover {
                color: blue;
              }
              .input-number {
                width: 2.5em;
                margin: 0 0.25em;
              }
              .code-layout {
                display: flex;
                align-items: center;
              }
            `}</style>
          </div>
        </>
    </Panel>
  );
};

export default Component;